import { createStyles } from '@mantine/core';
import { useMemo } from 'react';

const useAlignStyle = () => {
  const useStyles = useMemo(
    () =>
      createStyles({
        start: {
          justifyContent: 'flex-start',
        },
        end: { justifyContent: 'flex-end' },
        center: { justifyContent: 'center' },
      }),
    []
  );

  return useStyles();
};

export default useAlignStyle;
